<ng-container *hardwareForm="{}; let formGroup = form">
  <div class="flex flex-col w-full mt-2 mb-4">
    <div class="flex items-center justify-between">
      <h1 class="text-color font-semibold text-2xl">{{ '#HARDWARE_MANAGEMENT.PAGES.CREATE.TITLE' | translate }}</h1>
    </div>
  </div>

  <div class="flex flex-col sm:flex-row w-full border-solid border border-secondary p-3 mb-3 gap-4 justify-between items-center" style="background-color: var(--chipColor)">
    <div class="flex flex-col sm:flex-row gap-2 sm:gap-8 sm:items-center flex-grow w-full">
      <label class="soft-label font-semibold text-sm">{{ '#HARDWARE_MANAGEMENT.FORM.KUNDE.LABEL' | translate }}</label>
      <div class="w-full sm:w-72 lg:max-w-[20rem]">
        @if (activeUserAccount(); as userAccount) {
          <div class="soft-input readonly w-full">
            {{userAccount.number}} - {{userAccount.name}}
          </div>
        }
        <ng-template #customerSelectedTemplate let-entity="entity">
          {{ entity?.nummer }} - {{ entity?.kurzbez }}
        </ng-template>
      </div>
    </div>
    <button class="soft-button link flex-shrink-0 w-full sm:w-auto" (click)="formGroup.reset()">Zurücksetzen</button>
    <button class="soft-button primary flex-shrink-0 w-full sm:w-auto" [disabled]="formGroup.invalid" (click)="create(formGroup)">Hardware anlegen</button>
  </div>

  <form [formGroup]="formGroup" class="w-full flex flex-col gap-4 py-2">
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
      <div class="w-full">
        <label class="soft-label soft-label-top w-full">{{ '#HARDWARE_MANAGEMENT.FORM.HOSTNAME.LABEL' | translate }}</label>
        <soft-input class="mt-0.5" formControlName="hostname" placeholder="{{ '#HARDWARE_MANAGEMENT.FORM.HOSTNAME.PLACEHOLDER' | translate }}"></soft-input>
      </div>

      <div class="w-full">
        <label class="soft-label soft-label-top w-full">{{ '#HARDWARE_MANAGEMENT.FORM.BENUTZER.LABEL' | translate }}</label>
        <soft-input class="mt-0.5" formControlName="benutzer" placeholder="{{ '#HARDWARE_MANAGEMENT.FORM.BENUTZER.PLACEHOLDER' | translate }}"></soft-input>
      </div>

      <lib-typ-input [required]="true"></lib-typ-input>
      <lib-hersteller-input [required]="true"></lib-hersteller-input>
      <lib-produkt-input [required]="true"></lib-produkt-input>

      <div>
        <label class="soft-label soft-label-top w-full mb-0.5">{{ '#HARDWARE_MANAGEMENT.FORM.SERIENNUMMER.LABEL' | translate }}</label>
        <soft-input class="mt-0.5" formControlName="seriennummer" placeholder="{{ '#HARDWARE_MANAGEMENT.FORM.SERIENNUMMER.PLACEHOLDER' | translate }}"></soft-input>
      </div>

      <soft-ktostamm-standort-input></soft-ktostamm-standort-input>

      <div class="w-full">
        <label class="soft-label soft-label-top w-full mb-0.5">{{ '#HARDWARE_MANAGEMENT.FORM.STANDORT.LABEL' | translate }}</label>
        <soft-input class="mt-0.5" formControlName="standort" placeholder="{{ '#HARDWARE_MANAGEMENT.FORM.STANDORT.PLACEHOLDER' | translate }}"></soft-input>
      </div>



      <!-- <div class="w-full">
      <label class="soft-label soft-label-top w-full">{{ '#HARDWARE_MANAGEMENT.FORM.SOFTLINEID.LABEL' | translate }}</label>
      <soft-input class="mt-0.5" formControlName="autoid" placeholder="{{ '#HARDWARE_MANAGEMENT.FORM.SOFTLINEID.PLACEHOLDER' | translate }}"></soft-input>
    </div> -->


  </div>

  <!-- -->
  <div class="flex w-full">
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mt-6 w-full">
      <div class="w-full lg:col-start-1 lg:col-end-3">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-3">
          <ng-container *ngTemplateOutlet="formSection"></ng-container>
        </div>
      </div>

      <div class="lg:col-start-3 lg:col-end-3">
        <div class="w-full flex sm:mt-[1.375rem]">
          <div class="flex justify-between items-center w-full py-0.5">
            <label class="soft-label soft-label-top w-full">{{ '#HARDWARE_MANAGEMENT.FORM.IP_STATISCH.LABEL' | translate }}</label>
            <soft-toggle-switch formControlName="ip_statisch" trueValue="J" falseValue="N"></soft-toggle-switch>
          </div>
        </div>
        <div class="flex justify-between items-center w-full py-0.5">
          <label class="soft-label soft-label-top w-full">{{ '#HARDWARE_MANAGEMENT.FORM.IP_DHCP.LABEL' | translate }}</label>
          <soft-toggle-switch formControlName="ip_dhcp" trueValue="J" falseValue="N"></soft-toggle-switch>
        </div>
        <div class="flex justify-between items-center w-full py-0.5">
          <label class="soft-label soft-label-top w-full">{{ '#HARDWARE_MANAGEMENT.FORM.IP_DHCP_RESERVIERUNG.LABEL' | translate }}</label>
          <soft-toggle-switch formControlName="ip_dhcp_reservierung" trueValue="J" falseValue="N"></soft-toggle-switch>
        </div>
        <!-- <div class="flex justify-between items-center w-full py-0.5">
        <label class="soft-label soft-label-top w-full">SOFTLINE-ID</label>
        <soft-toggle-switch formControlName="ip_statisch" trueValue="J" falseValue="N"></soft-toggle-switch>
      </div> -->
    </div>
  </div>

  <ng-template #formSection>
    <div class="w-full">
      <label class="soft-label soft-label-top w-full">{{ '#HARDWARE_MANAGEMENT.FORM.DOMAIN.LABEL' | translate }}</label>
      <soft-input class="mt-0.5" formControlName="domaene" placeholder="{{ '#HARDWARE_MANAGEMENT.FORM.DOMAIN.PLACEHOLDER' | translate }}"></soft-input>
    </div>

    <div>
      <label class="soft-label soft-label-top w-full mb-0.5">{{ '#HARDWARE_MANAGEMENT.FORM.ARBEITSGRUPPE.LABEL' | translate }}</label>
      <soft-input class="mt-0.5" formControlName="arbeitsgruppe" placeholder="{{ '#HARDWARE_MANAGEMENT.FORM.ARBEITSGRUPPE.PLACEHOLDER' | translate }}"></soft-input>
    </div>

    <div class="w-full">
      <label class="soft-label soft-label-top w-full mb-0.5">{{ '#HARDWARE_MANAGEMENT.FORM.MAC_ADRESSE.LABEL' | translate }}</label>
      <soft-input class="mt-0.5" formControlName="mac_adresse" placeholder="{{ '#HARDWARE_MANAGEMENT.FORM.MAC_ADRESSE.PLACEHOLDER' | translate }}"></soft-input>
    </div>

    <div class="w-full">
      <label class="soft-label soft-label-top w-full">{{ '#HARDWARE_MANAGEMENT.FORM.IP_ADRESSE.LABEL' | translate }}</label>
      <soft-input class="mt-0.5" formControlName="ip_adresse" placeholder="{{ '#HARDWARE_MANAGEMENT.FORM.IP_ADRESSE.PLACEHOLDER' | translate }}"></soft-input>
    </div>

    <lib-subnetzmaske-input></lib-subnetzmaske-input>

    <div class="w-full">
      <label class="soft-label soft-label-top w-full">{{ '#HARDWARE_MANAGEMENT.FORM.GATEWAY.LABEL' | translate }}</label>
      <soft-input class="mt-0.5" formControlName="gateway" placeholder="{{ '#HARDWARE_MANAGEMENT.FORM.GATEWAY.PLACEHOLDER' | translate }}"></soft-input>
    </div>

    <div class="w-full">
      <label class="soft-label soft-label-top w-full mb-0.5">{{ '#HARDWARE_MANAGEMENT.FORM.DNS1.LABEL' | translate }}</label>
      <soft-input class="mt-0.5" formControlName="dns1" placeholder="{{ '#HARDWARE_MANAGEMENT.FORM.DNS1.PLACEHOLDER' | translate }}"></soft-input>
    </div>

    <div class="w-full">
      <label class="soft-label soft-label-top w-full">{{ '#HARDWARE_MANAGEMENT.FORM.DNS2.LABEL' | translate }}</label>
      <soft-input class="mt-0.5" formControlName="dns2" placeholder="{{ '#HARDWARE_MANAGEMENT.FORM.DNS2.PLACEHOLDER' | translate }}"></soft-input>
    </div>
  </ng-template>
</div>

<!-- -->

<div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mt-6">
  <lib-betriebssystem-input></lib-betriebssystem-input>

  <div class="w-full">
    <label class="soft-label soft-label-top w-full mb-0.5">{{ '#HARDWARE_MANAGEMENT.FORM.LIZENZKEY.LABEL' | translate }}</label>
    <soft-input class="mt-0.5" formControlName="lizenzkey" placeholder="{{ '#HARDWARE_MANAGEMENT.FORM.LIZENZKEY.PLACEHOLDER' | translate }}"></soft-input>
  </div>

  <div class="w-full">
    <label class="soft-label soft-label-top w-full mb-0.5">{{ '#HARDWARE_MANAGEMENT.FORM.TEAMVIEWER_ID.LABEL' | translate }}</label>
    <soft-input class="mt-0.5" formControlName="teamviewerid" placeholder="{{ '#HARDWARE_MANAGEMENT.FORM.TEAMVIEWER_ID.PLACEHOLDER' | translate }}"></soft-input>
  </div>

  <div class="w-full">
    <label class="soft-label soft-label-top w-full mb-0.5">{{ '#HARDWARE_MANAGEMENT.FORM.TEAMVIEWER_PW.LABEL' | translate }}</label>
    <soft-input class="mt-0.5" formControlName="teamviewer_passwort" placeholder="{{ '#HARDWARE_MANAGEMENT.FORM.TEAMVIEWER_PW.PLACEHOLDER' | translate }}"></soft-input>
  </div>

  <div class="w-full">
    <label class="soft-label soft-label-top w-full mb-0.5">{{ '#HARDWARE_MANAGEMENT.FORM.LIEFERDATUM.LABEL' | translate }}</label>
    <soft-date-input class="mt-0.5" formControlName="lieferdatum" placeholder="{{ '#HARDWARE_MANAGEMENT.FORM.LIEFERDATUM.PLACEHOLDER' | translate }}"></soft-date-input>
  </div>

  <div class="w-full">
    <label class="soft-label soft-label-top w-full mb-0.5">{{ '#HARDWARE_MANAGEMENT.FORM.AUSSCHEIDEDATUM.LABEL' | translate }}</label>
    <soft-date-input class="mt-0.5" formControlName="ausscheidedatum" placeholder="{{ '#HARDWARE_MANAGEMENT.FORM.AUSSCHEIDEDATUM.PLACEHOLDER' | translate }}"></soft-date-input>
  </div>

  <lib-garantietyp-input class="w-full"></lib-garantietyp-input>
  <lib-supporttyp-input class="w-full"></lib-supporttyp-input>

  <div class="w-full">
    <label class="soft-label soft-label-top w-full mb-0.5">{{ '#HARDWARE_MANAGEMENT.FORM.SERVICE_TAG.LABEL' | translate }}</label>
    <soft-input class="mt-0.5" formControlName="service_tag" placeholder="{{ '#HARDWARE_MANAGEMENT.FORM.SERVICE_TAG.PLACEHOLDER' | translate }}"></soft-input>
  </div>

  <div class="w-full">
    <label class="soft-label soft-label-top w-full mb-0.5">{{ '#HARDWARE_MANAGEMENT.FORM.EXPRESS_SERVICE_TAG.LABEL' | translate }}</label>
    <soft-input class="mt-0.5" formControlName="express_service_tag" placeholder="{{ '#HARDWARE_MANAGEMENT.FORM.EXPRESS_SERVICE_TAG.PLACEHOLDER' | translate }}"></soft-input>
  </div>
</div>
</form>
</ng-container>

